import { render, staticRenderFns } from "./WizardPage.vue?vue&type=template&id=514b2355&"
import script from "./WizardPage.vue?vue&type=script&lang=js&"
export * from "./WizardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports